var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { themeGet } from '@styled-system/theme-get';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import { getPaletteColor } from 'pcln-design-system';
import { ChevronLeft, ChevronRight } from 'pcln-icons';
import { getNextMonthLabel, getPrevMonthLabel } from '../utils/ariaLabelGenerators';
var LeftArrow = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    display: none;\n    ", " {\n      ", "\n    }\n    background-color: ", ";\n    padding-left: 24px;\n    padding-right: 0;\n    margin: 0;\n    margin-top: 24px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: 0;\n    border-radius: ", ";\n    cursor: ", ";\n  }\n"], ["\n  &&& {\n    display: none;\n    ", " {\n      ", "\n    }\n    background-color: ", ";\n    padding-left: 24px;\n    padding-right: 0;\n    margin: 0;\n    margin-top: 24px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: 0;\n    border-radius: ", ";\n    cursor: ", ";\n  }\n"])), function (props) { return props.theme.mediaQueries[1]; }, function (props) {
    return !props.isMobile &&
        "\n        display: block;\n      ";
}, getPaletteColor('background.lightest'), themeGet('borderRadii.md'), function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); });
var RightArrow = styled(LeftArrow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    display: none;\n    ", " {\n      ", "\n    }\n    left: auto;\n    right: 0;\n    padding-left: 0;\n    padding-right: 24px;\n  }\n"], ["\n  &&& {\n    display: none;\n    ", " {\n      ", "\n    }\n    left: auto;\n    right: 0;\n    padding-left: 0;\n    padding-right: 24px;\n  }\n"])), function (props) { return props.theme.mediaQueries[1]; }, function (props) {
    return !props.isMobile &&
        "\n        display: block;\n      ";
});
function Arrow(_a) {
    var isDisabled = _a.isDisabled, isMobile = _a.isMobile, isPrev = _a.isPrev, _b = _a.monthCount, monthCount = _b === void 0 ? 0 : _b, _c = _a.monthsToShow, monthsToShow = _c === void 0 ? 1 : _c, use2024DesignSeti = _a.use2024DesignSeti, props = __rest(_a, ["isDisabled", "isMobile", "isPrev", "monthCount", "monthsToShow", "use2024DesignSeti"]);
    var ariaLabel = useMemo(function () {
        var label = isPrev ? getPrevMonthLabel(monthCount) : getNextMonthLabel(monthCount, monthsToShow);
        return "Show ".concat(label).concat(isDisabled ? ' Disabled' : '');
    }, [isPrev, monthCount, monthsToShow]);
    var color = isDisabled ? 'background.tint' : use2024DesignSeti ? 'primary.base' : 'text.base';
    return isPrev ? (React.createElement(LeftArrow, __assign({ "aria-label": ariaLabel, disabled: isDisabled, isMobile: isMobile }, props),
        React.createElement(ChevronLeft, { color: color }))) : (React.createElement(RightArrow, __assign({ "aria-label": ariaLabel, disabled: isDisabled, isMobile: isMobile }, props),
        React.createElement(ChevronRight, { color: color })));
}
export default memo(Arrow);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Arrow.js.map